
import { Component, Vue, Watch } from "vue-property-decorator";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import LeadService from "@/services/leadService";
import ChannelService from "@/services/lead/ChannelService";
import ActionService from "@/services/lead/ActionService";

import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import DateRangePicker from "vue2-daterange-picker";
import vSelect from "vue-select";
import {
  HumanizeDurationLanguage,
  HumanizeDuration,
} from "humanize-duration-ts";

@Component({
  components: {
    LayoutDefault,
    DateRangePicker,
    vSelect,
  },
})
export default class Leadlist extends Vue {
  /**
   * @type Instance
   * For manager data on lead backend routes
   */
  private leadService = new LeadService();

  /**
   * @type Instance
   * For manager data on channel service backend routes
   */
  private channelService = new ChannelService();

  /**
   * @type Instance
   * For manager data on channel service backend routes
   */
  private actionService = new ActionService();

  /**
   * @type Boolean
   * help control validation export lead to pabx
   */
  private PabxValidation: boolean = false;

  /**
   * @type Object
   * Data list lead from return backend
   */
  private listLead: any;

  /**
   * @type Array
   * List attributes on filter platform custom
   */
  private listAttribute: any = [
    {
      name: "",
      label: "",
    },
  ];

  /**
   * @type Object
   * contains data from run filter on list leads
   */
  private filter: any = {
    attribute: "",
    attrContent: "",
    date: {
      startDate: "",
      endDate: ""
    },
    id_status: [],
    id_status_contact: [],
    id_action: [],
    referer: "",
    origin: "",
    plugin: "",
    export: "",
    notWorked: null as null|{ label:string, startDate:string, endDate: string },
    checkboxFilters: [] as string[]
  };

  private cacheFilter() {
    localStorage.setItem(
      "checkbox-filter",
      JSON.stringify(this.filter.checkboxFilters)
    );

    localStorage.setItem(
      "attribute-filter",
      JSON.stringify(this.filter.attribute)
    );
  }

  /**
   * @type Object
   * insert new lead
   */
  private lead: any = {
    name: null,
    phone: null,
    email: null,
    cpf: null,
    details: null,
    plugin: "manual",
    origin: "dashboard",
    is_hot_lead: false,
    id_platform: this.$auth.user().id_platform,
    action: null,
  };

  private leadAllFields: any = {};
  private leadHistory: any = [];
  private deleteIdleadHistory: any;
  private modalLead: any = "";
  private modalName: any = "";
  private modalStatus: any = "";
  /**
   * @type boolean
   * Help to control error message
   */
  private showDangerAlert: boolean = false;
  private dangerAlertMessage: string = "";

  /**
   * @type boolean
   * Help to control success message
   */
  private showSuccessAlert: boolean = false;
  private successAlertMessage: string = "";

  /**
   * @type object
   * Help control error form for send or not
   */
  private leadFormError: object = {
    name: { state: null, message: "Campo Obrigatório" },
    phone: { state: null, message: "Campo Obrigatório" },
    email: { state: null, message: "Email inválido" },
    cpf: { state: null, message: "CPF inválido" },
  };

  /**
   * @type
   * Help to control show loading icon
   */
  private loading: boolean = false;
  private modalLoading: boolean = false;

  /**
   * @type Any
   * get date select in ranger filter modal
   */
  private dateRange: any = {
    startDate: "",
    endDate: "",
  };

  /**
   * @type Array
   * set options status on filter modal
   */
  private statusOptions = [
    { code: 1, label: "Lead" },
    { code: 3, label: "Conversão" },
    { code: 8, label: "Auto conversão" },
    { code: 4, label: "Atendimento" },
    { code: 15, label: "Agendamento" },
    { code: 16, label: "Recusa" },
    { code: 23, label: "Improdutivo" },
  ];

  /**
   * @type Array
   * set options channel status on filter modal
   */
  private channelStatus = [];

  /**
   * @type Array
   * set options channel platform on filter modal
   */
  private channelPlatform = [
    { id_channel: null, label: "Não exportado" },
  ];

  /** Not worked filter options */
  private notWorkedOptions = [
    { label: "Hoje", value: 0 },
    { label: "Nos últimos 7 dias", value: 7 },
    { label: "Nos últimos 15 dias", value: 15 },
    { label: "Nos últimos 30 dias", value: 30 },
    { label: "Nunca", value: 3650 },
  ];

  /**
   * @type Array
   * set options action platform on filter modal
   */
  private actionPlatform = [];

  /**
   * @type Array
   * Define columns from datatables
   */
  private columns = [
    {
      data: "cl-wc-id_lead",
      name: "cl-wc-id_lead",
      title: "Clever ID",
      orderable: true,
    },
    {
      data: "clh_lead-wc-id_lead_history",
      name: "clh_lead-wc-id_lead_history",
      title: "History ID",
      orderable: false,
      searchable: false,
      visible: false,
    },
    {
      data: "name",
      name: "name",
      title: "Nome",
      orderable: true,
      defaultContent: "--",
      searchable: true,
    },
    {
      data: "phone",
      name: "phone",
      title: "Telefone",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "email",
      name: "email",
      title: "E-mail",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "score-weclever",
      name: "score-weclever",
      title: "Score Weclever",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "strategy",
      name: "strategy",
      title: "Estratégia",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "details",
      name: "details",
      title: "Detalhes",
      orderable: false,
      defaultContent: "--",
    },
    {
      data: "clh_lead-wc-created_at",
      name: "clh_lead-wc-created_at",
      title: "Data inserção",
      orderable: true,
    },
    {
      data: "cs_status-wc-label",
      name: "cs_status-wc-label",
      title: "Status",
      orderable: true,
    },
    {
      data: "clh_last-wc-fk_id_status",
      name: "clh_last-wc-fk_id_status",
      title: "id status",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: false,
    },
    {
      data: "clh_last-wc-fk_id_action",
      name: "clh_last-wc-fk_id_action",
      title: "Ação",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: false,
    },
    {
      data: "clh_last-wc-created_at",
      name: "clh_last-wc-created_at",
      title: "Data ult. status",
      orderable: true,
      defaultContent: "--",
    },
    {
      data: "clh_lead-wc-referer",
      name: "clh_lead-wc-referer",
      title: "Referer",
      orderable: false,
    },
    {
      data: "clh_lead-wc-origin",
      name: "clh_lead-wc-origin",
      title: "Origem",
      orderable: false,
      defaultContent: "--",
    },
    {
      data: "clh_lead-wc-plugin",
      name: "clh_lead-wc-plugin",
      title: "Plugin",
      orderable: false,
      defaultContent: "--",
    },
    {
      data: "cl_export-wc-fk_id_channel",
      name: "cl_export-wc-fk_id_channel",
      defaultContent: "--",
      visible: false,
    },
    {
      data: "clh_lead-wc-export_date",
      name: "clh_lead-wc-export_date",
      defaultContent: "--",
      visible: false,
    },
    {
      data: "clh_last-wc-id_lead_history",
      name: "clh_last-wc-id_lead_history",
      title: "Last History ID",
      orderable: false,
      searchable: false,
      visible: false,
    },
  ];
  private adminOnlyColumns: string[] = [];

  /**
   * @type Array
   * Config columns visible on datatables
   */
  private columnsVisible = [0, 2, 3, 4, 5, 6, 7, 8, 9, 11, 12, 13, 14, 15];

  private get columnsVisibleChunck() {
    let perChunk = 2; // items per chunk
    let result = this.columnsVisible.reduce((resultArray: any, item, index) => {
      const chunkIndex = Math.floor(index / perChunk);

      if (!resultArray[chunkIndex]) {
        resultArray[chunkIndex] = []; // start a new chunk
      }

      resultArray[chunkIndex].push(item);

      return resultArray;
    }, []);
    return result;
  }

  /**
   * @type Array
   * Help for control attributes show in display and query database
   */
  private attributesVisible = ["email", "name", "phone", "details", 'score-weclever', 'strategy'];

  /**
   * @type Array
   * Set config for buttons datatable
   */
  private buttons: any = [];

  private hDuration: HumanizeDuration = new HumanizeDuration(
    new HumanizeDurationLanguage()
  );

  private get timeStatusConvertion() {
    if (
      this.leadHistory &&
      this.leadHistory[this.leadHistory.length - 1].created_at &&
      this.leadHistory[this.leadHistory.length - 1].name ==
        "lead_finished_sale" &&
      this.leadAllFields &&
      this.leadAllFields.date &&
      this.$auth.user().profile === "admin"
    ) {
      let calcDiff = (this.$moment(this.leadAllFields.date) as any).diff(
        this.$moment(this.leadHistory[this.leadHistory.length - 1].created_at)
      );

      return this.hDuration.humanize(calcDiff, {
        language: "pt",
        units: ["y", "mo", "d", "h", "m", "s"],
        round: true,
      });
    }
    return 0;
  }

  private get dateConversion() {
    if (
      this.leadHistory &&
      this.leadHistory[this.leadHistory.length - 1].created_at &&
      this.leadHistory[this.leadHistory.length - 1].name == "lead_finished_sale"
    ) {
      return this.leadHistory[this.leadHistory.length - 1].created_at;
    }
    return 0;
  }

  /**
   * Method created life cycle
   */
  private async created() {
    let self = this;

    /** Query filters */
    let keys = Object.keys(this.$route.query);
    let n = keys.length;
    let queryLowerCase: {[key: string]: any} = {};
    while (n--) {
      let key = keys[n];
      queryLowerCase[key.toLowerCase()] = this.$route.query[key];
    }

    // Lead ID
    if (queryLowerCase.cleverid) {
      this.filter.attribute = "cl-wc-id_lead";
      this.filter.attrContent = queryLowerCase.cleverid;
    }
    // Group by history
    if (typeof queryLowerCase.groupbyhistory !== 'undefined') {
      if (!this.filter.checkboxFilters.includes('groupByHistory'))
        this.filter.checkboxFilters.push('groupByHistory');
    }
    // Action ID
    if (queryLowerCase.actionid)
        this.filter.id_action = Array.isArray(queryLowerCase.actionid) ? queryLowerCase.actionid.map(Number) : [Number(queryLowerCase.actionId)];
    /** End of query filters */

    // get attributes from platform
    this.leadService
      .attribute(this.$auth.user().id_platform)
      .then((response: any) => {
        this.listAttribute = JSON.parse(JSON.stringify(response));
        this.listAttribute.forEach((attr, key) => {
          if (
            attr.id_platform != null &&
            attr.id_platform > 0 &&
            attr.is_internal === null &&
            attr.name != "score-weclever" &&
            attr.name != "strategy"
          ) {
            if (attr.name == "platform_lead_id") {
              this.listAttribute[key].label =
                this.$auth.user().platform_name[0].toUpperCase() +
                this.$auth.user().platform_name.slice(1) +
                " ID";
              this.columns.push({
                data: attr.name,
                name: attr.name,
                title:
                  this.$auth.user().platform_name[0].toUpperCase() +
                  this.$auth.user().platform_name.slice(1) +
                  " ID",
                orderable: true,
                defaultContent: "--",
                searchable: true,
                visible: false,
              });
            } else {
              this.columns.push({
                data: attr.name,
                name: attr.name,
                title: attr.label,
                orderable: true,
                defaultContent: "--",
                searchable: true,
                visible: false,
              });
            }
            this.columnsVisible.push(this.columns.length - 1);
          }
        });
        this.listAttribute.push({ name: "cl-wc-id_lead", label: "Clever ID" });

        // add attributes retrict for internal profiles
        this.listAttribute.forEach((element) => {
          if (element.is_internal && element.is_internal.includes(this.$auth.user().profile)) {
            this.columns.push({
              data: element.name,
              name: element.name,
              title: element.label,
              orderable: false,
              defaultContent: "--",
              searchable: false,
              visible: false,
            });
            this.columnsVisible.push(this.columns.length - 1);
          }
        });

        this.actionService.indexStatus("action_active").then(
          (result) => {
            this.actionPlatform = result.body;

            const action_platform: any = this.actionPlatform.find((e: any) => e.name === 'recompra');

            this.filter.id_action.push(action_platform.id_action);

            this.createDataTable();
          },
          (error) => {
            console.log(error);
          }
        );
      });

    this.channelService.channelStatus().then((response: any) => {
      this.channelStatus = response ? response : [];
    });

    this.channelService.index().then((response: any) => {
      if (response && response.length > 0) {
        this.channelPlatform = this.channelPlatform.concat(response);
      }
    });

    this.actionService.indexStatus("action_active").then(
      (result) => {
        this.actionPlatform = result.body;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  /**
   * Method filter list lead
   */
  private sendFilter() {
    this.listLead.ajax.reload();
    this.hideModal("modal-filter");
  }

  /**
   * Method to clerar filters on list lead
   */
  private clearFilter() {
    this.filter.attribute = "";
    this.filter.attrContent = "";
    this.filter.date = {
      startDate: "",
      endDate: ""
    };
    this.filter.id_status = [];
    this.filter.id_action = [];
    this.filter.id_status_contact = [];
    this.filter.referer = "";
    this.filter.origin = "";
    this.filter.plugin = "";
    this.filter.export = "";
    this.filter.notWorked = null;
    this.filter.checkboxFilters = [];
    localStorage.removeItem("attribute-filter");
    localStorage.removeItem("checkbox-filter");

    this.listLead.ajax.reload();
    this.hideModal("modal-filter");
  }

  private mountedFilter(d: any) {

    d.filterAttr = false;
    d.groupByHistory = this.filter.checkboxFilters.includes('groupByHistory');
    d.id_user = this.$auth.user().id_user;
    d.id_platform = this.$auth.user().id_platform;
    d.platform_attributes = this.listAttribute;
    d.show_attributes = (this.listAttribute.filter((attr:any) => this.attributesVisible.includes(attr.name) ? true : false)).map(e => e.id_lead_attribute)

    d.table_filter_apply = [];
    d.columns.forEach((col, key) => {
      if (col.data == this.filter.attribute) {
        d.columns[key].search.value = this.filter.attrContent;
        d.filterAttr = true;
      }
      // filter date update
      if (
        col.data == "clh_last-wc-created_at" &&
        this.filter.date.startDate &&
        this.filter.date.startDate != ""
      ) {
        d.table_filter_apply.push('clh_last');
        let filterDate: any = [];
        if (this.filter.date.startDate) {
          filterDate.push(
            (this.$moment(this.filter.date.startDate) as any).format(
              "YYYY-MM-DD"
            ) + " 00:00:00"
          );
          filterDate[0] = this.$moment(filterDate[0], "YYYY-MM-DD HH:mm:ss");
          filterDate[0] = this.$moment
            .utc(filterDate[0])
            .format("YYYY-MM-DD HH:mm:ss");
        }
        if (this.filter.date.endDate) {
          filterDate.push(
            (this.$moment(this.filter.date.endDate) as any).format(
              "YYYY-MM-DD"
            ) + " 24:00:00"
          );
          filterDate[1] = this.$moment(filterDate[1], "YYYY-MM-DD HH:mm:ss");
          filterDate[1] = this.$moment
            .utc(filterDate[1])
            .format("YYYY-MM-DD HH:mm:ss");
        }
        d.columns[key].search.value = filterDate.length > 0 ? filterDate : "";
      }
      // filter status
      if (
        col.data == "clh_last-wc-fk_id_status" &&
        this.filter.id_status.length > 0
      ) {
        d.table_filter_apply.push('clh_last');
        const tmp_id: any = [];
        this.filter.id_status.forEach((status: any) => {
          tmp_id.push(status.code);
        });
        d.columns[key].search.value = tmp_id;
        d.columns[key].search.cond = "OR";
      }
      // filter action
      if (
        col.data == "clh_last-wc-fk_id_action" &&
        this.filter.id_action.length > 0
      ) {
        d.table_filter_apply.push('clh_last');
        const tmp_id: any = [];
        this.filter.id_action.forEach((action: any) => {
          tmp_id.push(action);
        });
        d.columns[key].search.value = tmp_id;
        d.columns[key].search.cond = "OR";
      }
      // filter status contact
      if (
        col.data == "pabxf-wc-idStatusLigacao" &&
        this.filter.id_status_contact.length > 0
      ) {
        d.table_filter_apply.push('pabxf');
        const tmp_id: any = [];
        this.filter.id_status_contact.forEach((channelStatus: any) => {
          tmp_id.push(channelStatus.id_status);
        });
        d.columns[key].search.value = tmp_id;
        d.columns[key].search.cond = "OR";
      }
      // filter referer
      if (col.data == "clh_lead-wc-referer" && this.filter.referer != "") {
        d.table_filter_apply.push('clh_lead');

        let tmp_ref = this.filter.referer.split(" ");
        if (Array.isArray(tmp_ref)) {
          tmp_ref.forEach((element, key) => {
            tmp_ref[key] = "%" + tmp_ref[key] + "%";
          });
          d.columns[key].search.value = tmp_ref;
          d.columns[key].search.cond = "AND";
          d.columns[key].search.compare = "like";
        } else {
          d.columns[key].search.value = this.filter.referer;
        }
      }
      // filter origin
      if (col.data == "clh_lead-wc-origin" && this.filter.origin != "") {
        d.table_filter_apply.push('clh_lead');

        d.columns[key].search.value = this.filter.origin;
      }
      // filter plugin
      if (col.data == "clh_lead-wc-plugin" && this.filter.plugin != "") {
        d.table_filter_apply.push('clh_lead');

        d.columns[key].search.value = this.filter.plugin;
      }
      //filter export channel
      if (
        col.data == "cl_export-wc-fk_id_channel" &&
        this.filter.export.length > 0
      ) {
        d.table_filter_apply.push('cl_export');

        const tmp_id: any = [];
        this.filter.export.forEach((channelExport: any) => {
          if (channelExport.id_channel || channelExport.id_channel === null) tmp_id.push(channelExport.id_channel);
        });
        if (tmp_id.length > 0) {
          d.columns[key].search.value = tmp_id;
          d.columns[key].search.cond = "OR";
        }
      }
    });
    if (this.filter.notWorked !== null ) {
      d.table_filter_apply.push('cle_notWorked');
      d.columns[d.columns.length] = {
        data: "cle_notWorked-wc-worked_at",
        name: "cle_notWorked-wc-worked_at",
        title: "notWorked_lead",
        orderable: false,
        defaultContent: "--",
        searchable: false,
        visible: false,
        search:{
          value: [
            this.$moment().startOf('day').subtract(this.filter.notWorked.value, 'day').utc().format("YYYY-MM-DD HH:mm:ss"),
            this.$moment().add(1, 'minute').utc().format("YYYY-MM-DD HH:mm:ss")
          ],
          not: true
        }
      }
    }
    d.table_filter_apply = [...new Set(d.table_filter_apply)];

    if (this.filter.checkboxFilters.includes('onlyMine'))
      d.columns.find(col => col.name === 'cs_user-wc-name').search.value = this.$auth.user().name;

    return d;
  }

  private get usingNotWorkedFilter() {
    return this.filter.notWorked !== null;
  }

  private get filteringOnlyByLeadStatus() {
    return Array.isArray(this.filter.id_status) && this.filter.id_status.length === 1 && this.filter.id_status[0].code === 1;
  }

  private statusFilterInput() {
    if (this.usingNotWorkedFilter && !this.filteringOnlyByLeadStatus) {
      this.filter.id_status = [this.statusOptions.find(e => e.code === 1)];
    }
  }

  private notWorkedFilterInput() {
    let dateFilterSelected = this.filter.date.startDate !== "" && this.filter.date.endDate !== "";
    let differenceInDays = dateFilterSelected ? (this.$moment(this.filter.date.endDate) as any).diff(this.$moment(this.filter.date.startDate), 'days') : null;

    if (!dateFilterSelected) {
      let today = this.$moment().hour(12).minute(0).second(0);
      this.filter.date.startDate = this.$moment(today).subtract(7, 'days').toDate();
      this.filter.date.endDate = today.toDate();

    } else if (dateFilterSelected && differenceInDays > 7) {
      this.filter.date.startDate = this.$moment(this.filter.date.endDate as Date).subtract(7, 'days').toDate();
    }

    if (!this.filteringOnlyByLeadStatus) {
      this.filter.id_status = [this.statusOptions.find(e => e.code === 1)];
    }
  }

  private dateFilterInput(selectedRange) {
    let differenceInDays = (this.$moment(selectedRange.endDate) as any).diff(this.$moment(selectedRange.startDate), 'days');

    if (this.usingNotWorkedFilter && differenceInDays > 7) {
      this.filter.date.startDate = this.$moment(selectedRange.endDate as Date).subtract(7, 'days').toDate();
      this.filter.date.endDate = selectedRange.endDate;
    }

    if (this.usingNotWorkedFilter && !this.filteringOnlyByLeadStatus) {
      this.filter.id_status = [this.statusOptions.find(e => e.code === 1)];
    }
  }

  /**
   * Method join commands for create datatable
   */
  private createDataTable() {
    let self = this;

    this.buttons.push({
      extend: "colvis",
      text: '<i class="fas fa-list"></i>',
      titleAttr: "Colunas",
      className: "datatable-buttons mr-2 ml-3 pr-0 pl-0 border-10",
      columns: this.columnsVisible,
    });

    this.buttons.push({
      extend: "filter",
    });

    if (
      this.$auth.user().profile === "admin" ||
      this.$auth.user().profile === "operator"
    ) {
      // create column for control export
      this.columns.push({
        data: "cs_channel-wc-label",
        name: "cs_channel-wc-label",
        title: "Exportado",
        orderable: false,
        defaultContent: "--",
        searchable: true,
        visible: false,
      });
      this.columnsVisible.push(this.columns.length - 1);

      // add column name attendant
      this.columns.push({
        data: "cs_user-wc-name",
        name: "cs_user-wc-name",
        title: "Consultor",
        orderable: false,
        defaultContent: "--",
        searchable: false,
        visible: this.$auth.user().profile === "admin",
      });
      this.adminOnlyColumns.push("cs_user-wc-name");
      if (this.$auth.user().profile === "admin") {
        this.columnsVisible.push(this.columns.length - 1);
        this.listAttribute.push({
          name: "cs_user-wc-name",
          label: "Consultor",
        });
      }

      // add column status contact
      this.columns.push({
        data: "pabxf-wc-statusLigacaoDesc",
        name: "pabxf-wc-statusLigacaoDesc",
        title: "Status do contato",
        orderable: true,
        defaultContent: "--",
      });
      this.columnsVisible.push(this.columns.length - 1);
      this.listAttribute.push({
        name: "pabxf-wc-statusLigacaoDesc",
        label: "Status do contato",
      });

      // add column status contact
      this.columns.push({
        data: "pabxf-wc-idStatusLigacao",
        name: "pabxf-wc-idStatusLigacao",
        title: "Id status do contato",
        orderable: true,
        defaultContent: "--",
        searchable: false,
        visible: false,
      });
    }

    // add column attendant evaluation
    this.columns.push({
      data: "cae-wc-evaluation",
      name: "cae-wc-evaluation",
      title: "Avaliação",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: true,
    });
    this.columnsVisible.push(this.columns.length - 1);
    this.listAttribute.push({
      name: "cae-wc-evaluation",
      label: "Avaliação",
    });

    // add column attendant evaluation details
    this.columns.push({
      data: "cae-wc-details",
      name: "cae-wc-details",
      title: "Obs. da avaliação",
      orderable: false,
      defaultContent: "--",
      searchable: false,
      visible: true,
    });
    this.columnsVisible.push(this.columns.length - 1);
    this.listAttribute.push({
      name: "cae-wc-details",
      label: "Obs. da avaliação",
    });

    let visibleColumnsCookie = this.$cookies.get(
      this.$auth.user().platform_name + "-attributesVisible"
    );

    if (visibleColumnsCookie) {
      this.columns.forEach((col, key) => {
        if (visibleColumnsCookie.hasOwnProperty(col.data)
          && (this.$auth.user().profile === "admin" || !this.adminOnlyColumns.includes(col.data))) {
            col.visible = visibleColumnsCookie[col.data] == true;
            if (col.visible && !this.attributesVisible.includes(col.data) &&
              col.data != "cl-wc-id_lead" &&
              col.data != "cs_user-wc-name" &&
              col.data != "cae-wc-evaluation" &&
              col.data != "cae-wc-details"
            ) {
                this.attributesVisible.push(col.data);
            }
        }
      });
    }

    // init datatable
    this.listLead = this.$("#listLead")
      .on("preXhr.dt", async (e, settings, d) => {})
      .on("xhr.dt", (e, settings, d, xhr) => {
        if (this.listLead.ajax.json() !== undefined) {
          // If phone column exists, will get all phones and listen to export changes with WebSocket
          if (this.listLead.ajax.json().data.length > 0 && this.listLead.ajax.json().data[0].phone) {
            let listedPhones = this.listLead.ajax.json().data.map(a => a.phone);
            this.$store.commit("leadList/LISTED_PHONES", listedPhones);
          }
        }
        if (xhr.status !== 200)
          this.$store.commit("navBarAlert/DANGER_ALERT", 'Erro ao carregar a listagem. Por favor, tente novamente mais tarde.');
      })
      .on("column-visibility.dt", (e, settings, column, state) => {
        let visibleColumnsCookie = this.$cookies.get(
          this.$auth.user().platform_name + "-attributesVisible"
        );
        visibleColumnsCookie[this.columns[column].data] = state;
        this.$cookies.set(
          this.$auth.user().platform_name + "-attributesVisible",
          JSON.stringify(visibleColumnsCookie),
          "1y",
          undefined,
          undefined,
          true,
          "Strict"
        );

        this.attributesVisible = [];
        this.listAttribute.forEach((attr, key) => {
          if (
            this.listLead.column(attr.name + ":name").visible() &&
            attr.name != "cl-wc-id_lead" &&
            attr.name != "cs_user-wc-name" &&
            attr.name != "cae-wc-evaluation" &&
            attr.name != "cae-wc-details"
          ) {
            this.attributesVisible.push(attr.name);
          }
        });
        this.listLead.ajax.reload();
      })
      .DataTable({
        fixedColumns:   {
            leftColumns: 0,
            rightColumns: 1,
        },
        autoWidth: false,
        responsive: true,
        processing: true,
        serverSide: true,
        colReorder: true,
        searchDelay: 1000,
        lengthMenu: [
          [10, 25, 100, 500, 1000, 2000, 3000],
          [10, 25, 100, 500, "1000", "2000", "3000"],
        ],
        pageLength: 10,
        scrollY: 500,
        scrollX: true,
        language: {
          sEmptyTable: "Nenhum registro encontrado",
          sInfo: "Mostrando de _START_ até _END_ de _TOTAL_ registros",
          sInfoEmpty: "Mostrando 0 até 0 de 0 registros",
          sInfoFiltered: "(Filtrados de _MAX_ registros)",
          sInfoPostFix: "",
          sInfoThousands: ".",
          sLengthMenu: "_MENU_ Qtd por página",
          sLoadingRecords: "Carregando...",
          sProcessing:
            '<div><div class="row justify-content-center m-5"><span role="status" class="spinner-border" style="width: 3rem; height: 3rem;"></span></div><div class="row justify-content-center mt-5">Loading ...</div></div>',
          sZeroRecords: "Nenhum registro encontrado",
          sSearch: "Pesquisar",
          oPaginate: {
            sNext: "Próximo",
            sPrevious: "Anterior",
            sFirst: "Primeiro",
            sLast: "Último",
          },
          oAria: {
            sSortAscending: ": Ordenar colunas de forma ascendente",
            sSortDescending: ": Ordenar colunas de forma descendente",
          },
          select: {
            rows: {
              _: "Selecionado %d linhas",
              "0": "Nenhuma linha selecionada",
              "1": "Selecionado 1 linha",
            },
          },
        },
        ajax: {
          url: process.env.VUE_APP_ROOT_API + "lead/datatable",
          crossDomain: true,
          type: "POST",
          contentType: "application/json",
          data: (d) => {
            return JSON.stringify(this.mountedFilter(d));
          }
        },
        columns: this.columns,
        columnDefs: [
          {
            className: "nowrap",
            targets: 0,
          },
          {
            className: "nowrap",
            render: (data, type, row) => {
              if (this.$auth.user().profile !== 'admin') {
                data = data ? data.substring(0, data.length - 4) + "..." : "";
              }
              return data;
            },
            targets: 3,
          },
          {
            className: "nowrap",
            render: (data, type, row) => {
              if (this.$auth.user().profile !== 'admin') {
                data = data ? data.substring(0, 10) + "..." : "";
              }
              return data;
            },
            targets: 4,
          },
          {
            className: "nowrap",
            targets: 8,
          },
          {
            render: (data, type, row) => {
              if (row["clh_last-wc-fk_id_status"] == 1) {
                return (
                  '<div class="column-status-lead"><span class="font-status-white">' +
                  data +
                  "</span><div class='icon-status-lead'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 3) {
                return (
                  '<div class="column-status-conversion"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-conversion'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 4) {
                return (
                  '<div class="column-status-call"><span class="font-status-white">' +
                  data +
                  "</span><div class='icon-status-call'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 5) {
                return (
                  '<div class="column-status-sale"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 8) {
                return (
                  '<div class="column-status-self-sale"><span class="font-status-white">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
               if (row["clh_last-wc-fk_id_status"] == 16) {
                return (
                  '<div class="column-status-refusal"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
               if (row["clh_last-wc-fk_id_status"] == 15) {
                return (
                  '<div class="column-status-scheduling"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
              if (row["clh_last-wc-fk_id_status"] == 23) {
                return (
                  '<div class="column-status-unproductive"><span class="font-status">' +
                  data +
                  "</span><div class='icon-status-sale'></div></div>"
                );
              }
              return (
                '<div class="column-status-lead"><span class="font-status-white">' +
                data +
                "</span><div class='icon-status-lead'></div></div>"
              );
            },
            targets: 9,
          },
          {
            className: "nowrap",
            targets: 12,
          },
          {
            title: "Ações",
            orderable: false,
            className: "nowrap",
            width: "10%",
            render: (data, type, row) => {
              let icons =
                "<a class=\"leadJourney\"><i class='fas fa-eye fa-lg'></i></a>";

              return icons;
            },
            targets: this.columns.length,
          },
          {
            render: (data, type, row, meta) => {
              if (
                this.columns[meta.col].data == "date_renovation" ||
                this.columns[meta.col].data == "date_sale" ||
                this.columns[meta.col].data == "clh_last-wc-created_at" ||
                this.columns[meta.col].data == "clh_lead-wc-created_at"
              ) {
                if (!data) return data;
                return (<any>this.$moment(data))
                  .tz("America/Sao_Paulo")
                  .format("DD-MM-YYYY HH:mm:ss");
              }

              else if (this.columns[meta.col].data === "cpf" && this.$auth.user().profile !== 'admin') {
                data = data ? data.substring(0, 4) + "..." : "";
              }

              else if (this.columns[meta.col].data === "clh_last-wc-fk_id_action") {
                self.actionPlatform.find((e: any) => {
                  if(e.id_action == data)
                    data = e.label;
                });
              }

              return data;
            },
            targets: "_all",
          },
        ],
        order: [[0, "desc"]],
        dom:
          '<"row"<"pl-3"l>>Brt<"row"<"col-sm-12 col-md-5"i><"col-sm-12 col-md-7"p>>',
        buttons: this.buttons,
        drawCallback: () => {
          this.onTableDraw();
        },
      });
    this.listLead.buttons().container().appendTo("#dt-actions")
    if (
      !this.$cookies.isKey(
        this.$auth.user().platform_name + "-attributesVisible"
      )
    ) {
      let visibleColumnsCookie = {};
      this.columns.map((col: any) => {
        visibleColumnsCookie[col.data] = col.visible;
      });
      this.$cookies.set(
      this.$auth.user().platform_name + "-attributesVisible",
      JSON.stringify(visibleColumnsCookie),
      "1y",
        undefined,
        undefined,
        true,
        "Strict"
    );
    }
  }

  /**
   * Method mounted from life cycle
   */
  private mounted() {
    let self = this;

    this.$.fn.dataTable.ext.buttons.filter = {
      text: '<i class="fas fa-filter"></i>',
      className: "datatable-buttons mr-2 pr-0 pl-0",
      titleAttr: "Filtrar",
      action: function (e, dt, node, config) {
        if(localStorage.getItem("checkbox-filter"))
          self.filter.checkboxFilters = JSON.parse(localStorage.getItem("checkbox-filter") as string);

        if(localStorage.getItem("attribute-filter"))
          self.filter.attribute = JSON.parse(localStorage.getItem("attribute-filter") as string);
        self.$bvModal.show("modal-filter");
      },
    };
  }

  private get isLeadJourneyModalLoading() {
    return (
      Object.keys(this.leadAllFields).length <= 0 ||
      this.leadHistory.length <= 0
    );
  }

  private hideModal(modal_id: string) {
    this.$bvModal.hide(modal_id);
  }

  // Listen to changes on export status of leads on the lead list.
  // State on VueX will be changed by an action called with WebSocket.
  private get updatedLeadExportLabel() {
    return this.$store.getters['leadList/updatedLeadExportLabel'];
  }
  @Watch("updatedLeadExportLabel")
  private onUpdatedLeadListExportStatusChange(val: any, oldVal: any) {
    if (val) {
      let rowsData = this.listLead.rows().data();
      for (let i = 0; i < this.listLead.rows().data().length; i++) {
        if (rowsData[i].phone === val.phone) {
          rowsData[i]['cs_channel-wc-label'] = val.text;
        }
      }
      this.listLead.rows().invalidate(); // Re-render list without making another ajax request
      this.onTableDraw();
    }
  }

  private onTableDraw() {
    this.$(".leadJourney").click((e) => {
      this.leadAllFields = {};
      this.leadHistory = [];
      this.leadService
        .show(
          this.listLead.row(this.$(e.target).parents("tr")).data()[
            "cl-wc-id_lead"
          ]
        )
        .then((response) => {
          this.leadAllFields = response;
        });

      this.leadService
        .historyIndex(
          this.listLead.row(this.$(e.target).parents("tr")).data()[
            "cl-wc-id_lead"
          ]
        )
        .then((response) => {
          this.leadHistory = response.length > 0 ? response : [0];
        });
      this.$bvModal.show("modal-lead-journey");
    });

  }
}
